"use client";

import Link from "next/link";
import Image from "next/image";
import { Typography } from "./Typography";
import { Button } from "./ui/button";
import { memo } from "react";

interface EmptyStateProps {
  variant: "not-found" | "no-trip" | "not-available" | "in_development";
  title?: string;
  description?: string;
  actionBtn?: {
    visable: boolean;
    title?: string;
    href?: string;
    onClick?: () => void;
    isLoading?: boolean;
  };
}

const IMAGE_MAP: Record<
  EmptyStateProps["variant"],
  { src: string; alt: string }
> = {
  "not-found": { src: "/not-found/not-found.svg", alt: "Not found" },
  "no-trip": { src: "/not-found/no-trip-found.svg", alt: "No trip found" },
  "not-available": { src: "/not-found/no-available.svg", alt: "No available" },
  in_development: {
    src: "/not-found/in_development.svg",
    alt: "In development",
  },
};

export const EmptyState = memo(function EmptyState({
  variant,
  title,
  description,
  actionBtn,
}: EmptyStateProps) {
  const image = IMAGE_MAP[variant];

  return (
    <main className="rounded-2xl bg-transparent p-4 text-sm text-[#898D91]">
      <div className="flex flex-col text-center justify-center items-center gap-2">
        <Image
          src={image.src}
          alt={image.alt}
          width={220}
          height={180}
          loading="eager"
          priority
          style={{ width: "auto", height: "auto" }}
        />
        <Typography variant="h6">{title || ""}</Typography>
        <Typography variant="body2" className="max-w-[300px] text-text-body">
          {description || ""}
        </Typography>

        {actionBtn?.visable && (
          <div className="min:w-[170px] my-4">
            <Button
              asChild
              onClick={actionBtn.onClick}
              isLoading={actionBtn.isLoading}
              className="btn-full-round"
            >
              <Link href={actionBtn.href || "/"}>{actionBtn.title || ""}</Link>
            </Button>
          </div>
        )}
      </div>
    </main>
  );
});
